module.exports = __webpack_public_path__ + "static/media/item3.2da556cd.png";